import React from 'react';
import siteContent from '../../data/siteContent';
import SectionTitle from '../common/SectionTitle';

function AboutSection() {
  return (
    <section id="sobre">
      <div className="container">
        <SectionTitle
          label={siteContent.about.label}
          title={siteContent.about.title}
          accent={siteContent.about.titleAccent}
          end={siteContent.about.titleEnd}
        />

        <div className="sobre-grid">
          <div className="sobre-text reveal">
            {siteContent.about.paragraphs.map((text, index) => (
              <p key={index}>{text}</p>
            ))}

            <div className="sobre-callout">
              Se você quer preço justo, estampa de qualidade e a segurança de receber seu pedido 
              <strong> você está no lugar certo.</strong>
            </div>
          </div>

          <div className="sobre-cards reveal">
            {siteContent.about.cards.map((card) => (
              <div className="scard" key={card.title}>
                <span className="scard-icon">{card.icon}</span>
                <h4>{card.title}</h4>
                <p>{card.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutSection;